<template>
  <div class="cart orderList" id="mypage-order-list-page">
    <h1 class="boxTitle mb15 notranslate">{{locale.order_list}}</h1>
    <div v-if="list.length" ref="mypageList" class="list" >
      <OrderListItem
        v-for="item in list"
        :key="item.order_id"
        :itemList="item"
        :locale="locale"
        :lang="lang" />
      <button
        v-if="next"
        type="button"
        ref="btnMore"
        class="btn btnFull btnRound btnWhite"
        @click="getOrderHistory">
        {{ locale.viewmore }}
      </button>
    </div>
    <div v-else class="noData notranslate">{{locale.order_nodata}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OrderListItem from '@/components/Mypage/OrderListItem'

export default {
  name: 'OrderList',
  props: [
    'lang',
    'locale'
  ],
  components: {
    OrderListItem
  },
  computed: {
    ...mapGetters({
      metaInfo: 'authentication/getMetaInfo',
      defaultBtnStyle: 'common/getDefaultBtnStyle'
    })
  },
  async mounted () {
    await this.getKey()
    await this.getOrderHistory()
  },
  data () {
    return {
      list: [],
      moreCount: 0,
      next: null,
      space: this.$store.state.authentication.space,
      key: this.$store.state.authentication.k
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'orderList'
      })
    },
    async getOrderHistory () {
      this.$store.commit('loading', true)
      const next = this.next
      const mypageType = this.$route.name.replace('my', '').toLowerCase()
      const data = {
        mypageType: mypageType,
        paging: {
          limit: 30,
          ...next && {
            next: next
          }
        }
      }
      const history = await this.$store.dispatch('guest/getMypageHistory', data)
      if (history && history.items) {
        this.list = this.list.map(x => {
          return {
            ...x,
            firstItem: false
          }
        }).concat(history.items.map((x, i) => {
          return {
            ...x,
            firstItem: i === 0 // 새로 불러온 첫 아이템으로 스크롤 하기 위한 flag
          }
        }))
      }
      this.$store.commit('loading', false)
      this.next = (history && history.next) || null
      this.scrollList()
      return history
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    init () {
      this.track()
    },
    scrollList () {
      this.$nextTick(() => {
        const list = this.$refs.mypageList
        const firstItem = document.querySelector('.firstItem')
        if (firstItem && this.moreCount > 0) {
          const top = firstItem.offsetTop
          const height = firstItem.offsetHeight
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          })
        }
        this.moreCount += 1
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding: 90px 0;
  text-align: center;
}
</style>
